import eth from "./eth.png";
import rink from "./rink.png";
import poly from "./poly.png";

const AssetsLogo = {
  Ethereum: eth,
  Rinkeby: rink,
  Polygon: poly,
};

export default AssetsLogo;
